/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchPassTypes = makeAsyncReducer(types.FETCH_PASS_TYPES);

const passTypes = mergeReducers(asyncDefaults([]), types.PREFIX, fetchPassTypes);

export default passTypes;
